/* Background presentation only. Header logo/clock and real navigation DOM stay owned by Home. */
(function () {
  'use strict';
  const storefront = window.BSStorefront;
  if (!storefront?.lifecycle || storefront.skullActor) return;
  // Devour's own capability gate: explicit Liquid config plus a supported theme role. It is
  // independent of Embedded Shop; development-only inspection narrows it further.
  if (!storefront.devourGate) {
    const roles = ['main', 'unpublished', 'development'];
    const enabled = () => {
      const node = document.querySelector('[data-bs-devour-config]');
      if (!node || !roles.includes(window.Shopify?.theme?.role)) return false;
      try { return JSON.parse(node.textContent).version === 1; } catch (ignored) { return false; }
    };
    storefront.devourGate = { enabled, development: () => enabled() && window.Shopify.theme.role === 'development' };
  }
  const actors = new WeakMap();
  function imageURL(value) {
    if (typeof value !== 'string' || !value.trim()) return null;
    try { const url = new URL(value, location.href); return /^https?:$/.test(url.protocol) ? url.href : null; } catch (ignored) { return null; }
  }
  function create(root) {
    const source = root.querySelector('[data-bs-skull-actor]');
    const initialState = source?.getAttribute('data-state');
    let state = 'idle', current = null, disposed = false;
    function setState(value) { if (state === value) return; state = value; source?.setAttribute('data-state', value); }
    function available(link) {
      const image = source?.querySelector('img');
      return !disposed && !current && root.isConnected && source?.isConnected && link?.isConnected &&
        !!image?.complete && image.naturalWidth > 0 && !!imageURL(image.currentSrc || image.getAttribute('src')) &&
        typeof source.animate === 'function';
    }
    function activate({ surface, link, viewport = null }) {
      if (!available(link)) return null;
      const image = source.querySelector('img');
      // Studio-only logical stage: map source rectangles without reflowing real Home.
      const scale = viewport ? Math.min(viewport.width / innerWidth, viewport.height / innerHeight) : 1;
      const mapRect = rect => viewport ? { left: (viewport.width - innerWidth * scale) / 2 + rect.left * scale,
        top: (viewport.height - innerHeight * scale) / 2 + rect.top * scale, width: rect.width * scale, height: rect.height * scale } : rect;
      const rect = mapRect(image.getBoundingClientRect()), tileRect = mapRect(link.getBoundingClientRect());
      const scene = document.createElement('div'); scene.className = 'bs-shop-devour';
      scene.setAttribute('aria-hidden', 'true'); scene.inert = true;
      const art = document.createElement('div'); art.className = 'bs-shop-devour__art';
      const sprite = document.createElement('img'); sprite.alt = ''; sprite.draggable = false;
      sprite.src = imageURL(image.currentSrc || image.getAttribute('src'));
      art.appendChild(sprite);
      function snapshotTile(original, bounds, surrounding = false) {
        const tile = document.createElement('div'); tile.className = 'bs-shop-devour__tile';
        const originalIcon = original.querySelector('.bs-home-hub__tile-icon')?.querySelector('img');
        const iconURL = originalIcon && imageURL(originalIcon.currentSrc || originalIcon.getAttribute('src'));
        if (iconURL) { const icon = document.createElement('img'); icon.alt = ''; icon.src = iconURL; tile.appendChild(icon); }
        const label = document.createElement('span'); label.textContent = original.querySelector('.bs-home-hub__tile-label')?.textContent || original.getAttribute('aria-label') || original.textContent;
        tile.appendChild(label);
        const style = getComputedStyle(original);
        for (const key of ['borderRadius', 'fontFamily', 'fontSize', 'letterSpacing', 'color']) if (style[key]) tile.style[key] = style[key];
        Object.assign(tile.style, { left: bounds.left + 'px', top: bounds.top + 'px', width: bounds.width + 'px', height: bounds.height + 'px' });
        if (surrounding) for (const key of ['background', 'border', 'boxShadow']) if (style[key]) tile.style[key] = style[key];
        return tile;
      }
      const tile = snapshotTile(link, tileRect);
      const surrounding = viewport ? [...root.querySelectorAll('[data-bs-home-handoff]')].filter(node => node !== link)
        .map(node => snapshotTile(node, mapRect(node.getBoundingClientRect()), true)) : [];
      const glow = document.createElement('div'); glow.className = 'bs-shop-devour__glow';
      const mask = document.createElement('div'); mask.className = 'bs-shop-devour__mask';
      const cue = document.createElement('div'); cue.className = 'bs-shop-devour__cue';
      Object.assign(art.style, { left: rect.left + 'px', top: rect.top + 'px', width: rect.width + 'px', height: rect.height + 'px' });
      scene.append(glow, art, ...surrounding, tile, mask, cue); surface.appendChild(scene);
      let released = false, interrupt = () => {};
      const lease = { scene, art, sprite, tile, surrounding, glow, mask, cue, rect, tileRect, source, link,
        opacity: getComputedStyle(source).opacity,
        pose: imageURL(source.getAttribute('data-bs-skull-pose') || ''),
        onInterrupt(fn) { interrupt = fn; },
        entering() { if (!released) setState('entering'); },
        holding() { if (!released) { setState('holding'); scene.setAttribute('data-state', 'waiting'); } },
        release() {
          if (released) return;
          released = true; setState('exiting'); scene.remove(); surface.removeAttribute('data-bs-devour');
          current = null; if (!disposed) setState('idle');
        },
        interrupt() { interrupt(); lease.release(); }
      };
      current = lease;
      return lease;
    }
    return { get state() { return state; }, available, activate,
      interrupt() { current?.interrupt(); },
      dispose() {
        if (disposed) return;
        disposed = true; current?.interrupt(); state = 'disposed';
        if (source) { if (initialState === null) source.removeAttribute('data-state'); else source.setAttribute('data-state', initialState); }
      }
    };
  }
  storefront.skullActor = { get: root => actors.get(root),
    unregister: storefront.lifecycle.register('bs-skull-actor', '.bs-home-hub', root => {
      if (!storefront.devourGate.enabled()) return;
      const actor = create(root); actors.set(root, actor);
      return () => { actor.dispose(); actors.delete(root); };
    })
  };
})();
